import {HEIGHT,WIDTH} from './model.mjs';

// Presentation only: existing documents retain their saved logical coordinates.
export function chartLayout({width,height,dispenserUnit}) {
 const unit=Math.min(dispenserUnit*1.5,width/11,height/11);
 const left=12,top=12,tableWidth=Math.max(unit*11,width-80),tableHeight=Math.max(unit*11,height-24);
 return {unit,left,top,width:tableWidth,height:tableHeight,split:left+tableWidth*10/11,bottom:top+tableHeight};
}
export function chartRodRect(layout,rods,rod) {
 const group=rods.filter(item=>item.length===rod.length);
 const index=group.indexOf(rod);
 return rod.length===10
  ? {x:layout.left+index*layout.unit,y:layout.bottom-10*layout.unit,width:layout.unit,height:10*layout.unit}
  : {x:layout.split,y:layout.bottom-(index+1)*layout.unit,width:layout.unit,height:layout.unit};
}
export function chartDropPoint(layout,x,y) {
 if(x<layout.left||x>layout.left+layout.width||y<layout.top+layout.unit||y>layout.bottom)return {x:NaN,y:NaN};
 return {x:x<layout.split?0:WIDTH/2,y:HEIGHT-1};
}
